import React from 'react';
import VpnKeyOutlinedIcon from '@mui/icons-material/VpnKeyOutlined';
import MedicalServicesOutlinedIcon from '@mui/icons-material/MedicalServicesOutlined';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import LocalFireDepartmentOutlinedIcon from '@mui/icons-material/LocalFireDepartmentOutlined';
import HealthAndSafetyOutlinedIcon from '@mui/icons-material/HealthAndSafetyOutlined';

type IconComponent = React.ComponentType<{ sx?: any }>;

// Single source of truth for duty icons, keyed by the stable backend duty key.
const DUTY_ICONS: Record<string, IconComponent> = {
  key_holder: VpnKeyOutlinedIcon,
  first_aider: MedicalServicesOutlinedIcon,
  fire_warden: LocalFireDepartmentOutlinedIcon,
  health_and_safety: HealthAndSafetyOutlinedIcon,
  mental_health_first_aider: MedicalServicesIcon,
};

/**
 * Returns a rendered icon element for a duty, looked up by its backend key.
 */
export const getDutyIcon = (dutyKey: string, size: number = 24): React.ReactElement | null => {
  const Icon = DUTY_ICONS[dutyKey];
  return Icon ? <Icon sx={{ fontSize: size }} /> : null;
};

/**
 * Returns the icon component class for a duty, looked up by its backend key.
 * Useful when the caller needs to control rendering (e.g. passing sx props).
 */
export const getDutyIconComponent = (dutyKey: string): IconComponent | null =>
  DUTY_ICONS[dutyKey] ?? null;
